import './installCompositionApi.js';
import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';
import App from './App.vue';

Vue.use(VueScrollTo);

const node = document.querySelector('#courses');

if (node) {
    new Vue({
        el: node,
        data: {
            states: JSON.parse(node.dataset.states),
        },
        render: (h) => h(App)
    });
}
